import { onMounted, onUnmounted } from 'vue';

export function useAutofillPrevention() {
    const disableAutofill = (input: HTMLInputElement) => {
        if (!input.hasAttribute('autocomplete')) {
            input.setAttribute('autocomplete', 'off');
            input.setAttribute('data-1p-ignore', '');
        }
    };
    const mutationObserver = new MutationObserver(() => {
        for (const input of document.body.querySelectorAll('input[type="text"]')) {
            disableAutofill(input as HTMLInputElement);
        }
    });

    onMounted(() =>
        mutationObserver.observe(document.body, {
            childList: true,
            subtree: true
        })
    );
    onUnmounted(() => mutationObserver.disconnect());
}
